import React, { useState, useEffect } from 'react';
import { translatedMessage } from '../../service/LanguageService';
import GeneralUtils from '../../utilities/GeneralUtils';

const CompetitionOtherConditionViewComponent = (props) => {
    const [competition, setCompetition] = useState(null);

    useEffect(() => {
        setCompetition(props?.competition);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.competition]);

    return (
        <>
            {//competition?.otherCondition &&
                <div className='col-12 mt-5'>
                    <h5 className='mb-1'>{translatedMessage('competition.requirements.otherCondition.info')}</h5>
                    <div className='w-full p-2 pcn-panel-border'>{GeneralUtils.dashIfNullForObject(competition?.otherCondition)}</div>
                </div>
            }
        </>
    );
};

export default CompetitionOtherConditionViewComponent;
